import React from "react";
import "./Footer.css";



function Footer() {
  return (
    <div className="main-footer">
      <div className="container">
        <div className="row">
          {/* Column1 */}
          <div className="col">
            <h4>SOCCER CLEATS LB</h4>
            <h6 className="list-unstyled">
              <li>961 71406079</li>
              <li>BEIRUT, LEBANON</li>
              <li>TYRE, LEBANON</li>
            </h6>
          </div>

          {/* Column2 */}
          <div className="col">
            <h4>Social Media</h4>
            <ui className="list-unstyled">
            <li><a href="https://www.instagram.com/soccercleatslb/"><img src="/assets/images/bg/ig.png" width={'25px'} />Instagram</a></li>
            <li><a href="https://www.Facebook.com"><img src="/assets/images/bg/fb2.png" width={'25px'} />Facebook</a></li>
            </ui>
          </div>

          {/* Column3 */}
          <div className="col">
            <h4>Customer Service</h4>
            <ui className="list-unstyled">
              <li><a href="/about">About</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ui>
          </div>

          {/* Column4 */}
          <div className="col">
            <h4>Payment Methods</h4>
            <ui className="list-unstyled">
            <li>Cash On Delivery</li>
            <li>Credit Card</li>
            <li>PayPal</li>
            </ui>        
          </div>
          
          {/* --- */}

        </div>
        <hr />
        <div className="row">
          <p className="col-sm">
            &copy;{new Date().getFullYear()} SOCCER CLEATS LB | All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;